import { brand } from '../config/brand';

/**
 * Migration layers: each entry is an (oldPrefix, newPrefix) pair.
 * Older layers run first so they don't collide with newer ones.
 * After migration the sentinel key is written under the *current* prefix.
 */
const MIGRATION_LAYERS: Array<{ oldPrefix: string; newPrefix: string }> = [];

// Layer 1: workalytix -> relix (direct hop if workalytix keys still exist)
if (brand.previousStoragePrefix2) {
  MIGRATION_LAYERS.push(
    { oldPrefix: `${brand.previousStoragePrefix2}_`, newPrefix: `${brand.storagePrefix}_` },
    { oldPrefix: `${brand.previousStoragePrefix2}.`, newPrefix: `${brand.storagePrefix}.` }
  );
}

// Layer 2: svodion -> relix
MIGRATION_LAYERS.push(
  { oldPrefix: `${brand.previousStoragePrefix}_`, newPrefix: `${brand.storagePrefix}_` },
  { oldPrefix: `${brand.previousStoragePrefix}.`, newPrefix: `${brand.storagePrefix}.` }
);

const MIGRATION_KEY = `${brand.storagePrefix}_storage_migrated`;

/**
 * One-time migration: copy old `workalytix_*` / `svodion_*` localStorage
 * keys to the current `relix_*` / `relix.*` prefixes, then mark as done.
 *
 * Safe to call on every app load — it's a no-op after the first run.
 */
export function migrateBrandStorageKeys(): void {
  try {
    if (localStorage.getItem(MIGRATION_KEY)) return;

    const keysToRename: Array<{ oldKey: string; newKey: string }> = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;

      for (const { oldPrefix, newPrefix } of MIGRATION_LAYERS) {
        if (key.startsWith(oldPrefix)) {
          keysToRename.push({ oldKey: key, newKey: newPrefix + key.slice(oldPrefix.length) });
          break;
        }
      }
    }

    for (const { oldKey, newKey } of keysToRename) {
      const value = localStorage.getItem(oldKey);
      if (value !== null && localStorage.getItem(newKey) === null) {
        localStorage.setItem(newKey, value);
      }
    }

    localStorage.setItem(MIGRATION_KEY, new Date().toISOString());
  } catch {
    // Non-critical — localStorage may be unavailable in some environments.
  }
}
